import { FormattedMessage } from '../../../../../taboola-common-frontend-modules/i18n';
import { useBidStrategyFormField } from '../BidStrategyV2/hooks/useBidStrategyFormField';

export const BidStrategyValue = () => {
    const { value: bidStrategy } = useBidStrategyFormField();

    return bidStrategy != null ? (
        <FormattedMessage
            tagName="div"
            id={`campaign.editor.campaignId.bidStrategy.${bidStrategy}`}
            defaultMessage={`Bid Strategy: ${bidStrategy}`}
        />
    ) : null;
};
